export default __webpack_public_path__ + "static/media/steps-cover-8-1.d6a52265.png";